import get from 'lodash/get';
export var selectIp = function selectIp(state) {
  return get(state, 'deviceInfo.ip');
};
export var selectHomeIataCode = function selectHomeIataCode(state) {
  var cityCode = get(state, 'homeAirport.home.city.code');
  var airportCode = get(state, 'homeAirport.home.airport.code');
  var homeIataCode = cityCode || airportCode;
  return homeIataCode ? homeIataCode.toUpperCase() : null;
};